import $ from "jquery";
import TweenMax from "gsap";
import ScrollMagic from "scrollmagic";
import { BREAKPOINTS } from "./model/config";
import {
  isMobileEnv,
  isMobileResolution,
  getResolution,
  truthy,
  getElementOffset,
  setCookie
  // getDecodedUriParams
} from "./util/util";
import SingletonModel from "./model/singletonModel";
import { TransitionController } from "./control/transitionController";
import Emitter from "./util/emitter";
import Config from './model/config';
import Navi from "./module/navi";
import HorizontalScrollingNavi from "./module/horizontalScrollingNavi";
import Intro from "./page/intro";
import Story from "./page/story";
import Change from "./page/change";
import Coupon from "./page/coupon";
import Event from "./page/event";
import Layer from "./module/Layer";
import Viewer from "./module/Viewer";
import {
  Modal,
} from './vendor/ModalPopupRWD';

(function() {
  "use strict";

  // variables
  let currentResolution = getResolution(BREAKPOINTS);

  const $window = $(window),
    $body = $("body"),
    $container = $("#container"),
    bgs = $(".bg-wrap")
      .children()
      .toArray()
      .reverse();

  const pages = $("> .section", $container);
  let pageIds = [];

  // instances
  const emitter = new Emitter();
  const model = SingletonModel.getInstance();

  let scrollMagicController = null;
  let transitionController = null;

  let naviPc = null,
    naviMobile = null;

  let intro, story,  change, coupon, event;

  const $scrollDownBtnWrap = $(".wrap-scrolldown"),
    $appDownloadWrap = $(".appdownload-wrap");

  let subscribeCompleteSequenceAnimation$ = null;
  let subscribeEnterScene$ = null;
  let subscribeSwitchPage$ = null;

  /*
   * implementation
   */
  $(document).ready(init);

  function init() {
    console.log("init ui.update.js");

    pages.each((index, page) => {
      pageIds.push(page.id);
    });

    model.pageIndexObj.d1 = 1;

    scrollMagicController = new ScrollMagic.Controller();

    if ($("#sectionIntro").length) {
      intro = new Intro({
        selector: "#sectionIntro",
        scrollMagicController: scrollMagicController,
        emitter: emitter
      }).init();

      model.pages.push(intro);
    }
    if ($("#sectionStory").length) {
      story = new Story({
        selector: "#sectionStory",
        scrollMagicController: scrollMagicController,
        emitter: emitter
      }).init();

      model.pages.push(story);
    }
    if ($("#sectionClass").length) {
      change = new Change({
        selector: "#sectionClass",
        scrollMagicController: scrollMagicController,
        emitter: emitter
      }).init();

      model.pages.push(change);
    }
    if ($("#sectionCoupon").length) {
      coupon = new Coupon({
        selector: "#sectionCoupon",
        scrollMagicController: scrollMagicController,
        emitter: emitter
      }).init();

      model.pages.push(coupon);
    }
    if ($("#sectionEvent").length) {
      event = new Event({
        selector: "#sectionEvent",
        scrollMagicController: scrollMagicController,
        emitter: emitter
      }).init();

      model.pages.push(event);
    }

    model.pages.map(page =>
      scrollMagicController.addScene(page.getScrollMagicScene())
    );

    transitionController = new TransitionController({
      emitter: emitter,
      pages: Array.prototype.slice.call(model.pages),
      d1: model.pageIndexObj.d1
    }).init();

    setEmitterEventHandler(true);

    if (isMobileResolution(currentResolution)) {
      // mobile resolution
      setNaviMobile();

      transitionController.setEnable(false).showAllPages();
    } else {
      // pc resolution
      setNaviPc();

      enableScrollMagicScenes(false);

      transitionController.setEnable(true).switchPage(model.pageIndexObj.d1);

      // switchBg(model.pageIndexObj.d1);

      allowContainerScroll(true);
    }

    // setCounter();
    setBtns();
    setLayers();
    setEvents();
    setImageViewer();
    setBtnIos();
    setYoutube();
    // setTrackingLink();
    // change index by hash
    if (isMobileResolution(currentResolution)) {
      //
    } else {
      const hash = location.hash ? location.hash.slice(1) : "",
        pageIndexByHash = pageIds.indexOf(hash) + 1;

      if (pageIndexByHash > 0 && pageIndexByHash <= pageIds.length) {
        transitionController.switchPage(pageIndexByHash, true);
      }
    }
  }

  function setImageViewer() {
    new Viewer();
  }

  function setNaviMobile() {
    if (naviMobile) naviMobile.destroy();

    const $wrap = $("#navQuick");

    naviMobile = new HorizontalScrollingNavi({
      /*
       * Navi options
       */
      btns: $(".quick-menu-list li a", $wrap),
      mouseoverCallback: function(obj) {},
      mouseoutCallback: function(obj) {},
      mousedownCallback: function(obj) {},
      mouseupCallback: function(obj) {},
      clickCallback: function(obj) {
        // {event, btn, prevActivatedIndex, index}
        if (isMobileResolution(currentResolution)) {
          // mobile
          setNaviMobilePosX(obj.index);

          const page = getPage(obj.index);

          setScrollTop(getElementOffset(page.getSelector()).top);
          model.pageIndexObj.d1 = obj.index;
        }
      },
      activateCallback: function(obj) {
        // {prevActivatedIndex, index}

        console.log("activate mobile navi :", obj);

        const $btns = $(naviMobile.getBtns()),
          $btn = $(naviMobile.getBtn(obj.index));

        $btns.closest("li").removeClass("is-active");
        $btn.closest("li").addClass("is-active");

        console.log("href :", $btn.attr("href"));

        // setting bg
        if ($btn.attr("href") == "#sectionIntro") {
          console.log("yes intro");
          $(".bg-story").fadeOut("slow");
          // $(".bg-intro").fadeIn();
          if ($('#sectionIntro').hasClass('section-intro-0212')) {
              $('.bg-intro-0212').fadeIn();
          } else {
              $('.bg-intro').fadeIn();
          }
        } else {
          if ($('#sectionIntro').hasClass('section-intro-0212')) {
              $('.bg-intro-0212').fadeOut('slow');
          } else {
              $('.bg-intro').fadeOut('slow');
          }
          // $(".bg-intro").fadeOut("slow");
          $(".bg-story").fadeIn();
          console.log("other section");
        }
      },

      /*
       * HorizontalScrollingNavi options
       */
      wrap: $wrap, // wrap
      handleClass: "handle", // handle class
      speed: 0.25, // how fast the handle will slide to position after you mouse up (0 ~ 1)
      positionedCallback: function(x, y) {
        // called when releasing handle or calling setX / setRatioX method, with the projected x, y position of the handle. projected value means the value the slider will have after finishing a sliding animation
        // console.log('HorizontalScrollingNavi positionedCallback :', x, naviMobile.getOffsetRatioByPosition(x));
      },
      dragStartCallback: function(x, y) {
        // called at the beginning of a drag with handle initial x, y values.
        // console.log('HorizontalScrollingNavi dragStartCallback :', x, y);
      },
      dragStopCallback: function(x, y) {
        // same as callback(x, y) but only called after a drag, not after call setX / setRatioX method.
        // console.log('HorizontalScrollingNavi dragStopCallback :', x, y);
      },
      animationCallback: function(x, y) {
        // called every animation loop, as long as the handle is being dragged or in the process of a sliding animation.
        // console.log('HorizontalScrollingNavi animationCallback :', x, y );
      }
    }).init();

    /*
     * HorizontalScrollingNavi public methods
     */
    // get all buttons
    // console.log( navi.getBtns() );

    // get one button. (1st button's index is 1.)
    // console.log( navi.getBtn(button index) );

    // get activated button index
    // console.log( navi.getActivatedIndex() );

    // activate one button, and deactivate other buttons. (1st button's index is 1.)
    // navi.activate(button index);

    // set buttons event handler
    // navi.setBtnsEventHandler(true / false);

    // get navi handle position ratio x (0 ~ 1)
    // console.log( navi.getRatioX() );

    // get offset ratio by position
    // console.log( navi.getOffsetRatioByPosition(-99) );

    // get handle node
    // console.log( navi.getHandle() );

    // set navi handle position by x
    // navi.setX(-99);

    // set navi handle position by ratio x (0 ~ 1)
    // navi.setRatioX(0.75);

    // get flag navi is draggbale
    // console.log( navi.isDraggable() );

    // enable dragging
    // navi.enable();

    // disable dragging
    // navi.disable();

    // set resize event handler
    // navi.setResizeEventHandler(true / false);

    // resize
    // navi.resize();

    // destroy
    // navi.destroy();
  }

  function setNaviPc() {
    if (naviPc) naviPc.destroy();

    naviPc = new Navi({
      btns: $("#navQuick .quick-menu-list li a"),
      mouseoverCallback: function(obj) {},
      mouseoutCallback: function(obj) {},
      mousedownCallback: function(obj) {},
      mouseupCallback: function(obj) {},
      clickCallback: function(obj) {
        if (obj.prevActivatedIndex === obj.index) return;

        // {event, btn, prevActivatedIndex, index}
        if (!isMobileResolution(currentResolution)) {
          // pc
          transitionController.switchPage(obj.index, true);

          allowContainerScroll(false);

          model.pageIndexObj.d1 = obj.index;
        }
      },
      activateCallback: function(obj) {
        // {prevActivatedIndex, index}
        const $btns = $(naviPc.getBtns()),
          $btn = $(naviPc.getBtn(obj.index));

        $btns.closest("li").removeClass("is-active");
        $btn.closest("li").addClass("is-active");

        console.log("href :", $btn.attr("href"));
      }
    }).init();

    naviPc.activate(model.pageIndexObj.d1);

    /*
     * Navi public methods
     */
    // get all buttons
    // console.log( naviPc.getBtns() );

    // get one button. (1st button's index is 1.)
    // console.log( naviPc.getBtn(button index) );

    // get activated button index
    // console.log( naviPc.getActivatedIndex() );

    // activate one button, and deactivate other buttons. (1st button's index is 1.)
    // naviPc.activate(button index);

    // set buttons event handler
    // naviPc.setBtnsEventHandler(true / false);

    // destroy
    // naviPc.destroy();
  }

  function setLayers() {
    //이벤트 유의사항 레이어
    $("body").on("click", '[data-module-id="layer"]', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      const $btn = $(this),
        layerSelector = $btn.attr("data-layer-target");

      console.log("layerSelector :", layerSelector);

      const _ = this;
      _.model = SingletonModel.getInstance();

      const layer = _.model.modalLayers[layerSelector];
      console.log("layer :", layer);

      if (layer) {
        layer.show();
      } else {
        _.model.modalLayers[layerSelector] = new Layer({
          layer: $(layerSelector),
          linked: $btn,
          options: {
            noScroll: false,
            keepDimmed: true
          },
          onBeforeShow: function() {
            console.log("onBeforeShow show modal layer");
            
            isMobileResolution(currentResolution) && enableScrollMagicScenes(false);

            _.model.isShowBodyFixedLayer = true;
          },
          onBeforeHide: function() {
            console.log("onBeforeHide show modal layer");

            isMobileResolution(currentResolution) && enableScrollMagicScenes(true);
            _.model.isShowBodyFixedLayer = false;
          },
          onShow: function() {
            console.log("onShowCallback");

            if (naviMobile) activateNaviMobile(model.pageIndexObj.d1);
          }
        });
      }
    });
  }

  function setBtns() {
    hideTooltipsDelayed();

    // cookie
    const $homeBtn = $(".go-home");
    $homeBtn.on("click", evt => {
      evt.preventDefault();

      setCookie("LineageM_WEB_VISIT_200129", false, 1);

      location.href = $homeBtn.attr("href");
    });
  }

  function setEvents() {
    $(window).on("scroll", evt => {
      const scrollTop = $window.scrollTop();

      if (isMobileResolution(getResolution(BREAKPOINTS))) {
        // mobile resolution
        if (scrollTop <= 0) {
          $appDownloadWrap.show();
        } else {
          $appDownloadWrap.hide();
        }
      } else {
        // pc resolution
      }
    });

    $(window).on("resize", evt => {
      if (intro) intro.resize(evt);
      if (story) story.resize(evt);
      if (change) change.resize(evt);
      if (coupon) coupon.resize(evt);
      if (event) event.resize(evt);

      resize(evt);
    });

    $(window).on("hashchange", evt => {
      // change index by hash

      if (isMobileResolution(currentResolution)) {
        //
      } else {
        const hash = location.hash ? location.hash.slice(1) : "",
          pageIndexByHash = pageIds.indexOf(hash) + 1;

        if (pageIndexByHash > 0 && pageIndexByHash <= pageIds.length) {
          transitionController.switchPage(pageIndexByHash, true);
        }
      }
    });
  }

  function resize(evt) {
    const resolution = getResolution(BREAKPOINTS);

    if (resolution !== currentResolution) {
      if (isMobileResolution(resolution)) {
        console.log("pc --> mobile");
        // change resolution : pc --> mobile

        if (naviPc) naviPc.destroy();
        setNaviMobile();

        transitionController.setEnable(false).showAllPages();

        // setEmitterEventHandler(true);

        model.pages.map(page => {
          scrollMagicController.removeScene(page.getScrollMagicScene());
        });

        model.pages.map(page => {
          page.resetScrollMagicScene();
          scrollMagicController.addScene(page.getScrollMagicScene());
        });

        const page = getPage(model.pageIndexObj.d1);
        setScrollTop(getElementOffset(page.getSelector()).top);
      } else {
        console.log("mobile --> pc :", model.pageIndexObj.d1);

        if (naviMobile) naviMobile.destroy();
        setNaviPc();

        // change resolution : mobile --> pc
        enableScrollMagicScenes(false);
        // setEmitterEventHandler(false);

        transitionController.setEnable(true).switchPage(model.pageIndexObj.d1);

        showHideAppdownloadWrapByIndex(model.pageIndexObj.d1);
        showHideScrollDownBtnByIndex(model.pageIndexObj.d1);

        allowContainerScroll(true);

        model.isEnableMouseWheel = true;
      }

      currentResolution = resolution;
    }
  }

  function enableScrollMagicScenes(flag) {
    model.pages.map(page => {
      page.enabledScrollMagicScene(flag);
      // page.getScrollMagicScene().enabled(flag);
    });
  }

  function getPage(d1) {
    return transitionController.getPage(d1);
  }

  function setScrollTop(val) {
    $("html, body").scrollTop(val);
  }

  function allowContainerScroll(flag) {
    /*
        truthy(flag)
            ? $container.css('overflow', 'visible')
            : $container.css('overflow', 'hidden');
        */
  }

  function setEmitterEventHandler(flag) {
    if (truthy(flag)) {
      if (!subscribeCompleteSequenceAnimation$) {
        subscribeCompleteSequenceAnimation$ = emitter.listen(
          "COMPLETE_SEQUENCE_ANIMATION",
          (data = {}) => {
            console.log("COMPLETE_SEQUENCE_ANIMATION pc emitter data :", data);

            allowContainerScroll(true);

            model.isEnableMouseWheel = true;
          }
        );
      }

      if (!subscribeSwitchPage$) {
        subscribeSwitchPage$ = emitter.listen("SWITCH", (data = { d1: 1 }) => {
          console.log("SWITCH pc emitter data :", data);

          const d1 = data.d1;

          if (naviPc) naviPc.activate(d1);

          showHideAppdownloadWrapByIndex(d1);
          showHideScrollDownBtnByIndex(d1);
          switchBg(d1);

          model.pageIndexObj.d1 = d1;

          allowContainerScroll(false);

          $window.scrollTop(0);
        });
      }

      if (!subscribeEnterScene$) {
        subscribeEnterScene$ = emitter.listen(
          "ENTER",
          (
            data = {
              page: null
            }
          ) => {
            console.log("ENTER mobile emitter data :", data);

            model.pageIndexObj.d1 = model.pages.indexOf(data.page) + 1;

            if (naviMobile) activateNaviMobile(model.pageIndexObj.d1);
          }
        );
      }
    } else {
      if (subscribeCompleteSequenceAnimation$) {
        subscribeCompleteSequenceAnimation$.unsubscribe();
        subscribeCompleteSequenceAnimation$ = null;
      }
      if (subscribeSwitchPage$) {
        subscribeSwitchPage$.unsubscribe();
        subscribeSwitchPage$ = null;
      }
      if (subscribeEnterScene$) {
        subscribeEnterScene$.unsubscribe();
        subscribeEnterScene$ = null;
      }
    }
  }

  function activateNaviMobile(index) {
    if (naviMobile) {
      naviMobile.activate(index);

      setNaviMobilePosX(index);
    }
  }

  function setNaviMobilePosX(index) {
    if (index < 1 || index > naviMobile.getBtns().length) return;

    const prev = index <= 1 ? 0 : index - 1,
      next = index > naviMobile.getBtns().length ? 0 : index + 1;

    if (!prev) {
      naviMobile.setRatioX(0); // go to left end.
      return;
    }

    if (!next) {
      naviMobile.setRatioX(1); // go to right end.
      return;
    }

    const btn = $(naviMobile.getBtn(prev));
    if (btn.length) naviMobile.setX(-btn.position().left);
  }

  function showHideAppdownloadWrapByIndex(index) {
    index <= 1 ? $appDownloadWrap.show() : $appDownloadWrap.hide();
  }

  function showHideScrollDownBtnByIndex(index) {
    index < pages.length ? showScrollDownBtn(true) : showScrollDownBtn(false);
  }

  function showScrollDownBtn(flag) {
    truthy(flag) ? $scrollDownBtnWrap.show() : $scrollDownBtnWrap.hide();
  }

  function hideTooltipsDelayed(delay, $ele, speed = 0.5) {
    if (isMobileEnv($body)) {
      // mobile env
      TweenMax.to($(".go-home .text"), 0.5, {
        delay: 1,
        autoAlpha: 0,
        ease: Cubic.easeOut
      });
    }

    TweenMax.to($(".btn-appdownload .text", $appDownloadWrap), 0.5, {
      delay: 1,
      autoAlpha: 0,
      ease: Cubic.easeOut
    });
  }

  function switchBg(index) {
    if (isMobileResolution(getResolution(BREAKPOINTS))) {
      // none
    } else {
      if (index <= 1) index = 1;

      const $bg = $(bgs[index - 1]);

      console.log("$bg :", $bg);

      $(bgs).hide();

      $bg.show();
    }
  }

  function setBtnIos(){
    if($('body').hasClass('pc')){
      $('.btn-ios').on('click', (e)=>{
        e.preventDefault();
        alert('모바일 앱스토어에서만 다운로드 가능합니다.')
      })
    }
  }

  function setYoutube() {
    const options = Config.movieModal.options,
      baseUrl = Config.movieModal.baseUrl,
      introMovieModal = new Modal(options);

    $('[data-module-id="youtube"]').on('click', e => {
      e.preventDefault();

      const youtubeId = $(e.currentTarget).attr('data-youtube-id');
      const youtubeURL = baseUrl + youtubeId; // + options.movieParams;

      introMovieModal.setYoutubeUrl(youtubeURL);
      introMovieModal.show();
    });
  }

  // function setTrackingLink () {
  //   let urlParams = getDecodedUriParams(decodeURI(location.href));

  //   if( !urlParams ) return false;

  //   if (Object.keys(urlParams).length) {
  //     let params = '?';

  //     Object.keys(urlParams).forEach((key, index) => {
  //       if (index !== 0) params += '&';
  //       params += `${key}=${encodeURI(urlParams[key])}`;
  //     });
    
  //     console.log(params);
  //     $('a[href="/preorder/record/200129/index"]').each(function () {
  //       const $this = $(this);
  //       const href = $this.attr('href');

  //       $this.attr('href', href + params);
  //     });
  //   }
  // }
  
})();
